import React, { useState } from 'react';
import { FeatureBadge } from './FeatureBadge';
import { SparklesIcon, LeafIcon, SmileIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function ProductHero() {
  const [activeImage, setActiveImage] = useState(0);
  const productImages = [{
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/07c7ddd2-46b9-4723-8619-76b4b0a70ce6.png?v=1764357542',
    alt: 'Faith & Fig Divine Wellness - Front View'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_5p98y85p98y85p98.png?v=1763928093',
    alt: 'Faith & Fig Divine Wellness - With Powder'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_1ktqnj1ktqnj1ktq.png?v=1764319022',
    alt: 'Faith & Fig Divine Wellness - Back View'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_2nvz7k2nvz7k2nvz.png?v=1764319121',
    alt: 'Faith & Fig Divine Wellness - Back View'
  }];
  const getVisibleThumbnails = () => {
    const totalImages = productImages.length;
    let startIndex = Math.max(0, activeImage - 1);
    if (startIndex + 3 > totalImages) {
      startIndex = totalImages - 3;
    }
    return productImages.slice(startIndex, startIndex + 3).map((img, idx) => ({
      ...img,
      originalIndex: startIndex + idx
    }));
  };
  const handlePrevImage = () => {
    setActiveImage(prev => prev === 0 ? productImages.length - 1 : prev - 1);
  };
  const handleNextImage = () => {
    setActiveImage(prev => prev === productImages.length - 1 ? 0 : prev + 1);
  };
  return <div className="w-full" data-id="element-347">
      {/* LAYOUT STRATEGY:
             Mobile: Use CSS Grid with [72% 26%] ratio.
             - The Image is 'aspect-square', which sets the strict height of the row.
             - The Badges are in the second column with explicit gap spacing.
             
             Desktop: Use Flexbox with smaller gap for tighter spacing.
          */}

      {/* === MOBILE LAYOUT (Grid) === */}
      <div className="lg:hidden w-full grid grid-cols-[72%_26%] gap-2" data-id="element-348">
        {/* Column 1: Image (Driver of Height) */}
        <div className="relative aspect-square w-full" data-id="element-349">
          {/* Brain & Mood Badge */}
          <div className="absolute -top-2 left-2 z-20" data-id="element-350">
            <span className="bg-[#c4d4c0] text-[#2d4a3a] text-[9px] font-bold px-2 py-1 rounded uppercase tracking-wide shadow-lg" data-id="element-351">
              Heart & Vitality
            </span>
          </div>

          {/* 90% Badge */}
          <div className="absolute -top-3 -right-3 bg-[#2d4a3a] text-white rounded-full w-14 h-14 flex flex-col items-center justify-center shadow-2xl z-20" data-id="element-352">
            <div className="text-lg font-bold text-[#d4af37]" data-id="element-353">90%</div>
            <div className="text-[6px] text-center leading-tight px-1 mt-0.5 uppercase" data-id="element-354">
              Feel the
              <br data-id="element-355" />
              benefits
            </div>
          </div>

          {/* Main Image */}
          <div className="w-full h-full bg-white rounded-2xl overflow-hidden shadow-lg relative z-10" data-id="element-356">
            <img src={productImages[activeImage].url} alt={productImages[activeImage].alt} className="w-full h-full object-contain p-3" data-id="element-357" />
          </div>
        </div>

        {/* Column 2: Badges (Follower of Height) - Increased spacing on mobile */}
        <div className="flex flex-col justify-start gap-5 h-full py-1" data-id="element-358">
          {/* We use overflow-hidden on the badge wrappers to ensure that if the content
            is slightly too big, it cuts off rather than breaking the grid alignment.
            */}
          <div className="w-full overflow-hidden flex justify-center" data-id="element-359">
            <FeatureBadge icon={<SparklesIcon className="w-3 h-3" data-id="element-361" />} label="Clinically-Studied Formula" compact data-id="element-360" />
          </div>
          <div className="w-full overflow-hidden flex justify-center" data-id="element-362">
            <FeatureBadge icon={<LeafIcon className="w-3 h-3" data-id="element-364" />} label="3,750mg Vitality Dosage" compact data-id="element-363" />
          </div>
          <div className="w-full overflow-hidden flex justify-center" data-id="element-365">
            <FeatureBadge icon={<SmileIcon className="w-3 h-3" data-id="element-367" />} label="Clean Energy No stimulants. No crashes." compact data-id="element-366" />
          </div>
        </div>
      </div>

      {/* === DESKTOP LAYOUT (Flex) - Reduced spacing on desktop === */}
      <div className="hidden lg:flex flex-row items-stretch gap-6" data-id="element-368">
        {/* Left Column: Image */}
        <div className="flex-1 relative" data-id="element-369">
          <div className="absolute -top-3 left-4 z-20" data-id="element-370">
            <span className="bg-[#c4d4c0] text-[#2d4a3a] text-xs font-bold px-3 py-1.5 rounded uppercase tracking-wide shadow-lg" data-id="element-371">
              CALM + FOCUS + PRESENCE
            </span>
          </div>
          <div className="absolute -top-4 -right-4 bg-[#2d4a3a] text-white rounded-full w-24 h-24 flex flex-col items-center justify-center shadow-2xl z-20" data-id="element-372">
            <div className="text-3xl font-bold text-[#d4af37]" data-id="element-373">90%</div>
            <div className="text-[9px] text-center leading-tight px-2 mt-1 uppercase" data-id="element-374">
              Feel the
              <br data-id="element-375" />
              benefits
            </div>
          </div>
          <div className="aspect-square bg-white rounded-2xl overflow-hidden shadow-lg h-full relative z-10" data-id="element-376">
            <img src={productImages[activeImage].url} alt={productImages[activeImage].alt} className="w-full h-full object-contain p-8" data-id="element-377" />
          </div>
        </div>

        {/* Right Column: Badges - Tighter spacing with gap-3 */}
        <div className="flex flex-col justify-start gap-3 flex-shrink-0 w-auto py-2" data-id="element-378">
          <FeatureBadge icon={<SparklesIcon className="w-5 h-5" data-id="element-380" />} label="Clinically-Studied Formula" compact data-id="element-379" />
          <FeatureBadge icon={<LeafIcon className="w-5 h-5" data-id="element-382" />} label="3,750mg Proven Clinical Dosage" compact data-id="element-381" />
          <FeatureBadge icon={<SmileIcon className="w-5 h-5" data-id="element-384" />} label="Clean Energy No stimulants. No crashes." compact data-id="element-383" />
        </div>
      </div>

      {/* THUMBNAILS SECTION */}
      <div className="mt-3 lg:mt-4" data-id="element-385">
        <div className="flex items-center gap-2 lg:gap-3" data-id="element-386">
          <button onClick={handlePrevImage} className="flex-shrink-0 w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-[#496f58] hover:bg-[#3d5a47] text-white flex items-center justify-center transition-all shadow-md" data-id="element-387">
            <ChevronLeftIcon className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-388" />
          </button>

          <div className="flex-1 grid grid-cols-3 gap-2 lg:gap-3" data-id="element-389">
            {getVisibleThumbnails().map(image => <button key={image.originalIndex} onClick={() => setActiveImage(image.originalIndex)} className={`
                  aspect-square bg-white rounded-lg overflow-hidden shadow-md
                  transition-all hover:shadow-lg
                  ${activeImage === image.originalIndex ? 'ring-2 lg:ring-4 ring-[#496f58]' : 'ring-1 ring-gray-200'}
                `} data-id="element-390">
                <img src={image.url} alt={image.alt} className="w-full h-full object-contain p-1 lg:p-2" data-id="element-391" />
              </button>)}
          </div>

          <button onClick={handleNextImage} className="flex-shrink-0 w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-[#496f58] hover:bg-[#3d5a47] text-white flex items-center justify-center transition-all shadow-md" data-id="element-392">
            <ChevronRightIcon className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-393" />
          </button>
        </div>

        <div className="text-center mt-2 text-xs text-gray-500" data-id="element-394">
          {activeImage + 1} / {productImages.length}
        </div>

        {/* TRUST LOGOS */}
        <div className="hidden lg:grid grid-cols-2 gap-6 lg:gap-8 pt-6 lg:pt-8 mt-6 lg:mt-8 border-t border-gray-200" data-id="element-395">
          <div className="text-left" data-id="element-396">
            <div className="font-bold text-xs lg:text-sm mb-1" data-id="element-397">BBC</div>
            <div className="font-serif text-base lg:text-lg font-bold text-gray-900 mb-1 lg:mb-2" data-id="element-398">
              DRAGONS' DEN
            </div>
            <p className="text-[10px] lg:text-xs text-gray-600 italic leading-tight" data-id="element-399">
              "The biblical botanical Christian women are using to restore their daily vitality"
            </p>
            <p className="text-[9px] lg:text-[10px] text-gray-400 mt-0.5 lg:mt-1" data-id="element-400">
              Sara Davies, Host
            </p>
          </div>
          <div className="text-left" data-id="element-401">
            <div className="font-serif text-xl lg:text-2xl font-bold text-gray-900 mb-1 lg:mb-2" data-id="element-402">
              Forbes
            </div>
            <p className="text-[10px] lg:text-xs text-gray-600 leading-tight" data-id="element-403">
              "The Most Concentrated, High-Impact Pomegranate Formula for Daily Vitality."
            </p>
          </div>
        </div>
      </div>
    </div>;
}